import React from "react";
import Pill from "./PillElement";

export const PreferredTemplatePill = () => {
  return <Pill
    color="blue"
    label={RESX.MessageTemplate.PreferredTemplate}
  />
}